/**
 * When every alarm code is selected we send a single -1 sentinel to the API
 * instead of the full list (~900 ids). The backend treats -1 as "no filter"
 * and skips the WHERE clause entirely, avoiding a query with hundreds of params.
 *
 * State still holds the real selection so the UI round-trips correctly; collapse
 * to the sentinel only happens at the edge where we know the full universe of codes.
 */
export const SELECT_ALL_CODE_ID = -1

/** Collapse a "select all" selection to the [-1] sentinel; otherwise pass through. */
export const collapseAllCodeIds = (selected: number[], allIds: number[]): number[] => {
  if (allIds.length === 0) {
    return selected
  }
  const selectedSet = new Set(selected)
  const allSelected = allIds.every((id) => selectedSet.has(id))
  return allSelected ? [SELECT_ALL_CODE_ID] : selected
}

/** Expand a stored [-1] sentinel back to the full id list for display. */
export const expandAllCodeIds = (value: number[] | undefined, allIds: number[]): number[] => {
  if (!value) {
    return []
  }
  if (allIds.length > 0 && value.includes(SELECT_ALL_CODE_ID)) {
    return allIds
  }
  return value
}
